import { setRangeMax } from './helpers';

export const setMaxPrice = setRangeMax('price');
